import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AirdropPage from '../Pages/Airdrop/AirdropPage';
import BridgePage from '../Pages/Bridge/BridgePage';
import TermsAndConditions from '../Pages/Privacy/TermsAndConditions';
import PrivacyPolicy from '../Pages/Privacy/PrivacyPolicy';
import AirdropClaim from '../Pages/AirdropClaim/AirdropClaim';
import { Vaults } from '../Pages/Vaults/Vaults';
import { isHidden } from '../utils/constants';

const CommonRoutes = () => {
  return (
    <div>
      <Routes>
        <Route path="*" element={<Navigate to={'/'} />} />
        <Route path="/" element={<Navigate to="/airdrop" replace />} />
        <Route path="/airdrop" element={<AirdropPage />} />
        <Route path="/airdrop/:referralCode" element={<AirdropPage />} />
        <Route path="/bridge" element={<BridgePage />} />
        <Route path="/vaults" element={<Vaults />} />
        {!isHidden && (
          <Route path="/airdrop-claim" element={<AirdropClaim />} />
        )}
        <Route path="/termsandconditions" element={<TermsAndConditions />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
      </Routes>
    </div>
  );
};

export default CommonRoutes;
